<template>
  <div class="ucrs-gallery ucrs-gallery--border">
    <div class="ucrs-gallery__inner">
      <ClientOnly>
        <LazySwiper
          :options="swiperOptions"
          navigation
          pagination
          nav-position="bottom-center"
          @slide-index="updateCurrentSlide"
        >
          <div
            v-for="(item, index) in property.floor_plans"
            :key="`PropertyFloorplans_${index}`"
            class="swiper-slide ucrs-gallery__overlay ucrs-gallery__overlay--small text-center cursor-pointer"
            tabindex="0"
            aria-label="Ingrandisci immagine"
            @keyup.enter="clickImage(index)"
            @click="clickImage(index)"
          >
            <NuxtImg
              class="ucrs-gallery__item ucrs-gallery__item--max-h"
              :src="$utilities.imgAlias(item.src)"
              :alt="item.title"
              :loading="index === 0 ? null : 'lazy'"
              :preload="index === 0"
              width="1024"
              height="576"
              fit="contain"
              format="webp"
              :modifiers="{ b: 'ffffff' }"
              sizes="sm:300px md:350px lg:1024px"
              aria-hidden="true"
            />
          </div>
        </LazySwiper>
      </ClientOnly>
      <div class="ucrs-gallery__counter">
        <span v-text="currentSlide"></span>/<span
          v-text="property.floor_plans.length"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyLightbox from '~/components/PropertyLightbox'
const LazySwiper = () => import('~/components/Swiper')

export default {
  components: {
    LazySwiper,
  },

  props: {
    property: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      currentSlide: 1,
      swiperOptions: {
        observer: true,
        observeParents: true,
        watchOverflow: true,
      },
    }
  },
  methods: {
    updateCurrentSlide(activeIndex) {
      this.currentSlide = activeIndex + 1
    },
    clickImage(index) {
      this.$oruga.modal.open({
        parent: this,
        component: PropertyLightbox,
        animation: 'ucrs-modal-',
        contentClass: 'ucrs-modal__container--center',
        width: 1230,
        props: {
          images: this.property.floor_plans,
          alt: `${this.property.title}, immagine`,
          startAt: index,
        },
      })
    },
  },
}
</script>

<style lang="postcss">
@import '~/assets/css/components/gallery';
</style>
